module.exports = __webpack_public_path__ + "imgs/gpbMobile1x.b94136cc.webp";